/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import translateMixin from '../mixins/translate-mixin.js';

const __vue_script__ = {
  mixins: [translateMixin],
  props: [
    "currency",
    "installments",
    "billet-installments",
    "orderBumps",
    "isBrazil",
    "loadingCurrency",
    "type",
    "foreignPrice",
  ],
  computed: {
    defaultCurrency() {
      return {
        value: 1,
        prefix: this.foreignPrice ? this.currency.prefix : "R$"
      }
    },
    periodicity() {
      return window.plan && window.plan.periodicity ? ({
        "daily": "por dia",
        "weekly": "por semana",
        "monthly": "por mês",
        "bimonthly": "por bimestre",
        "quarterly": "por trimestre",
        "half-yearly": "por semestre",
        "yearly": "por ano",
      })[window.plan.periodicity] : "";
    },
    _installments() {
      if (this.type === "billet-installments") {
        return this.billetInstallments;
      }
      return this.type === "billet" || this.type === "pix" ? 1 : this.installments
    },
    installmentsToShow() {
      if (!this.$translate && this._installments && this._installments > 1) {
        return `${this._installments}x`
      }
      return ""
    },
    price() {
      if (this.foreignPrice) return this.foreignPrice;

      var installments = window.product.billet_installments > 1 ? window.product.installments_billet : window.product.installments;

      if (['billet', 'pix'].includes(this.type) && this.orderBumps.length > 0) {
        var price = installments[1];
        for (var code of this.orderBumps) {
          price += window.offer?.order_bumps.find(data => data.offer_code === code).installments[1]
        }
        return price;
      }

      if (!this.$translate && this._installments) {
        return installments[this._installments];
      }
      return installments[1];
    },
    basePrice() {
      return window.product.installments[1];
    }
  }
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "total-to-pay" },
    [
      _c("multiple-order-bump-details", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: ["billet", "pix"].includes(_vm.type),
            expression: "['billet', 'pix'].includes(type)",
          },
        ],
        attrs: { type: _vm.type, "order-bumps": _vm.orderBumps },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex pt-1" }, [
        _c("span", { staticClass: "text-dark flex-fill" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("Total a pagar")) +
              " " +
              _vm._s(_vm.$t(_vm.periodicity)) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c(
          "h5",
          { staticClass: "mb-0" },
          [
            _vm._v("\n      " + _vm._s(_vm.installmentsToShow) + "\n      "),
            _c("format-money", {
              attrs: { currency: _vm.defaultCurrency, value: _vm.price },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.$translate && !_vm.foreignPrice
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-end pt-1" },
            [
              _vm.loadingCurrency
                ? _c("loading-spinner", { staticClass: "spinner-border-sm" })
                : _c(
                    "small",
                    { staticClass: "text-secondary" },
                    [
                      _vm._v("\n      *approx.\n      "),
                      _c("format-money", {
                        attrs: { currency: _vm.currency, value: _vm.basePrice },
                      }),
                    ],
                    1
                  ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.$translate && _vm._installments > 1
        ? _c("div", { staticClass: "d-flex pt-1" }, [
            _c("small", { staticClass: "text-secondary flex-fill" }, [
              _vm._v("Total à vista"),
            ]),
            _vm._v(" "),
            _c(
              "small",
              { staticClass: "text-secondary" },
              [
                _c("format-money", {
                  attrs: {
                    currency: _vm.defaultCurrency,
                    value: _vm.basePrice,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frontend/components/total-to-pay.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__